<template>
    <div v-if="$store.state.user.accessToken == ''">
        <router-view :key="$route.fullPath" />
        <vue-progress-bar></vue-progress-bar>
    </div> 

    <div class="main_rightcontent mainbody_cssclass" id="wrapper" v-else>
        <vue-progress-bar></vue-progress-bar>
        <div class="loadimg" style="display: none;">
            <span class="loader"></span>
        </div>
        <div class="sectionbody">
            <SideMenu />
            <div class="d-flex flex-column" id="content-wrapper">
                <div id="content">
                    <HeaderPage />
                    <div class="container-fluid p-0">
                        <router-view :key="$route.fullPath" />
                    </div>
                </div>

            </div>
        </div>
    
    </div>
</template>

<script >
import '../assets/css/style.css'
import '../assets/css/custom.css'

import HeaderPage from './layout/Header.vue';
import SideMenu from './layout/SideMenu.vue';
import axios from 'axios'
    export default {
        name: 'AdminPage',
        components: {
            SideMenu,
            HeaderPage
        },
        computed: {
            iRt() {
                return this.$store.state.isRefreshToken
            },
        },
        watch: {
            async iRt(newValue) {
                await this.refreshToken()
                return newValue
            },
        },
        async mounted() {
            this.$store.state.isAdmin = 2   
            let token = localStorage.getItem('supportSystemAdmin');
            let tokenFront = localStorage.getItem('supportSystemFront');
            if (!token && !tokenFront) {
                this.$store.state.user.accessToken = ''
                this.$router.push({ path: '/login' })
            }   
            this.refreshToken()
        },
        methods: {
            async refreshToken() {
                if (this.$store.state.user.accessToken == '') {
                    let token = localStorage.getItem('supportSystemAdmin');
                    if (token) {
                        this.$store.state.user.accessToken = token
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
                        await axios.get(process.env.VUE_APP_API_URL + 'authenticate/user-details')
                        .then((resp) => {
                            if (typeof resp.data.data == 'undefined'){
                                this.$store.state.user.accessToken = ''
                                this.$store.state.isActiveToken = ''
                                this.$store.state.user.userInfo = ''
                                localStorage.removeItem("supportSystemAdmin");
                                this.$toast.success('Your login session has expired for security reasons. Please log in again to continue.')
                                this.$router.push({
                                    path: '/login'
                                })
                            }
                            else if (resp.status == 200 && resp.data.status == 'success' && resp.data.data != '')                      {             
                                this.$store.state.user.userInfo = resp.data.data
                                this.$store.state.user.role_name = resp.data.data.role_name
                                this.$store.state.user.role_id = resp.data.data.role_id
                                this.$store.state.isActiveToken = 1
                                this.$store.state.isRefreshToken = 1
                                // }
                            }
                            else if (resp.status == 200 && resp.data.status == 'failure') {
                                // this.errorMessage = resp.data.data;
                                // this.errorRes = resp.data.message;
                                this.$store.state.user.accessToken = ''
                                this.$store.state.isActiveToken = ''
                                this.$store.state.user.userInfo = ''
                                localStorage.removeItem("supportSystemAdmin");
                                localStorage.removeItem("token");
                                this.$toast.success('Your login session has expired for security reasons. Please log in again to continue.')
                                this.$router.push({
                                    name: 'Login'
                                })
                            } else {
                                this.$toast.success('Your login session has expired for security reasons. Please log in again to continue.')
                                this.$router.push({
                                    name: 'Login'
                                })
                            }
                        })
                        .catch(error => {
                            this.errorMessage = error.message;
                            this.$store.state.user.accessToken = ''
                            this.$store.state.user.userInfo = ''
                            localStorage.removeItem("userInfo");
                            localStorage.removeItem("token");    
                            this.$router.push({
                                name: 'Login'
                            })
                        })
                    }
                }
            }
        },
    }
</script>